import Gallery from 'components/desktop/detail/main-section/main-section-left/gallery';
import ListSection from 'components/desktop/detail/main-section/main-section-left/list-section';
import MainContent from 'components/desktop/detail/main-section/main-section-left/main-content';
import MapSection from 'components/desktop/detail/main-section/main-section-left/map-section';
import PostContent from 'components/desktop/detail/main-section/main-section-left/post-content';
import PrivateNote from 'components/desktop/detail/main-section/main-section-left/private-note';
import SaleInformation from 'components/desktop/detail/main-section/main-section-left/sale-information';

const MainSectionLeft = () => (
  <div
    id='main-section-left'
    className='m-[-8px] flex w-full flex-col space-y-[28px] overflow-x-hidden p-[8px]'
  >
    <Gallery />
    <div className='flex flex-col space-y-[28px] rounded-[16px] bg-paper p-[24px] shadow-1'>
      <div className='flex flex-col space-y-[40px]'>
        <MainContent />
        <PostContent />
        <PrivateNote />
      </div>
      <SaleInformation />
      <ListSection />
      <MapSection />
      {/* <TagList /> */}
    </div>
  </div>
);

export default MainSectionLeft;
